import { StrollersFilter } from "@/mk2/apps/strollers/containers/Charts/Charts.actions";
import {
    PerFilterState,
    State,
    initialState,
    perFilterInitialState,
} from "@/mk2/apps/strollers/containers/Charts/Charts.reducers";
import { hashCode64 } from "@/mk2/helpers/hashes";
import { AppState } from "@/mk2/reducers";

export const hashStrollerFilter = (filter: StrollersFilter) => {
    return hashCode64(JSON.stringify(filter)).toString(16);
};

export const getChartsState = (state: AppState): State =>
    state.containers.strollers.charts || initialState;
export const getChartsPerFilterState = (
    state: AppState,
    filter: StrollersFilter = {},
): PerFilterState => getChartsState(state)[hashStrollerFilter(filter)] || perFilterInitialState;
